import React from "react";
import { Label } from "semantic-ui-react";

const FAST_TRACK_CONFIG = {
  rushed: { color: 'red', label: 'RUSHED' },
  rush: { color: 'red', label: 'RUSH' },
  expedited: { color: 'orange', label: 'EXPEDITED' },
  urgent: { color: 'orange', label: 'URGENT' },
};

const getFastTrackLabel = (cartProducts) => {
  if (!cartProducts || !cartProducts.length) return null;

  for (const product of cartProducts) {
    const productName = (product.name || '').toLowerCase();
    for (const [term, config] of Object.entries(FAST_TRACK_CONFIG)) {
      if (productName.includes(term)) {
        return config;
      }
    }
  }
  return null;
};

export const renderApplicationType = (applicant) => {
  const fastTrack = getFastTrackLabel(applicant.cartProducts);
  return (
    <span>
      {applicant.applicationType}
      {fastTrack && (
        <Label color={fastTrack.color} size="mini" style={{ marginLeft: '6px' }}>
          {fastTrack.label}
        </Label>
      )}
    </span>
  );
};
